<template>
    <v-hover v-slot:default="{ hover }">
        <router-link
            class="action-link d-flex align-center px-10 mx-5"
            :class="`${ isLight ? 'light ' : '' }${ isDark ? 'dark ' : '' }${ hover ? 'hover' : '' }`"
            :to="item.to"
        >
            <v-icon v-if="!!item.prependIcon" left>mdi-{{ item.prependIcon }}</v-icon>
            {{ item.title }}
        </router-link>
    </v-hover>
</template>

<script>
  export default {
    name: 'CTABtn',
    props: [
        'item',
        'light',
        'dark',
    ],
    computed: {
        isLight() { return this.light !== undefined },
        isDark() { return this.dark !== undefined || this.light === undefined },
    }
  }
</script>

<style>
.action-link {
    border: 2px solid #30B700;
    border-radius: 4px;
    padding: 4px 20px;
}

.action-link.hover {
	animation: pulse 1s 1;
}

.action-link,
.action-link > * {
    text-decoration: none !important;
    cursor: pointer;
    line-height: 1 !important;
    color: #ffffff !important;
}

.action-link.dark {
    background-color: rgba(45,42,41,0.5) !important;
}

.action-link.light {
    background-color: transparent !important;
}

@keyframes pulse {
	0% {
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
	}

	30% {
		transform: scale(1.05);
	}

	100% {
		box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
	}
}
</style>